(function () {
  function initTouchSupport() {
    var selectors = [
      '[data-gp-comp="ImageComparison"]',
      '.gp-image-comparison',
      '[class*="image-comparison"]',
      '[class*="before-after"]',
      '[class*="ImageComparison"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (container) {
        if (container.dataset.touchFixed) return;
        container.dataset.touchFixed = 'true';
        var handle =
          container.querySelector('[class*="handle"]') ||
          container.querySelector('[class*="slider"]') ||
          container.querySelector('input[type="range"]');
        if (!handle) return;
        if (handle.tagName === 'INPUT') {
          handle.style.touchAction = 'none';
          return;
        }
        var isDragging = false;
        handle.addEventListener('touchstart', function (e) {
          isDragging = true;
          e.preventDefault();
        }, { passive: false });
        document.addEventListener('touchmove', function (e) {
          if (!isDragging) return;
          e.preventDefault();
          var touch = e.touches[0];
          var rect = container.getBoundingClientRect();
          var ratio = (touch.clientX - rect.left) / rect.width;
          ratio = Math.min(1, Math.max(0, ratio));
          var percent = (ratio * 100).toFixed(2) + '%';
          handle.style.left = percent;
          var overlay =
            container.querySelector('[class*="overlay"]') ||
            container.querySelector('[class*="after"]') ||
            container.querySelectorAll('img, div')[1];
          if (overlay) {
            overlay.style.clipPath = 'inset(0 ' + (100 - ratio * 100).toFixed(2) + '% 0 0)';
          }
        }, { passive: false });
        document.addEventListener('touchend', function () {
          isDragging = false;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTouchSupport);
  } else {
    initTouchSupport();
  }
  setTimeout(initTouchSupport, 2000);
})();
